var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.$attrs.data.options),function(item){return _c('div',{key:item.id,staticClass:"item"},[_c('i',{staticClass:"fa fa-circle-o"}),_c('span',{staticStyle:{"padding":"0 16px"}},[_vm._v(_vm._s(item.value))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }